/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Optimization_TargetInputs */

const en_us2_optimization_target = /** @type {(inputs: Optimization_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optimization Target`)
};

const en_gb2_optimization_target = /** @type {(inputs: Optimization_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optimisation Target`)
};

/**
* | output |
* | --- |
* | "Optimization Target" |
*
* @param {Optimization_TargetInputs} inputs
* @param {{ locale?: "en-US" | "en-GB" }} options
* @returns {LocalizedString}
*/
export const optimization_target = /** @type {((inputs?: Optimization_TargetInputs, options?: { locale?: "en-US" | "en-GB" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Optimization_TargetInputs, { locale?: "en-US" | "en-GB" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en-GB") return en_gb2_optimization_target(inputs)
	return en_us2_optimization_target(inputs)
});